import { collection, query, where, getDocs, addDoc, updateDoc, doc, serverTimestamp, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { PayrollPeriod, PayrollPeriodStatus } from '../types';

const getCollection = (tenantId: string) => collection(db, 'tenants', tenantId, 'payroll_periods');

export const getPayrollPeriods = async (tenantId: string): Promise<PayrollPeriod[]> => {
  const q = query(getCollection(tenantId), orderBy('startDate', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as PayrollPeriod));
};

export const createPayrollPeriod = async (tenantId: string, period: Omit<PayrollPeriod, 'id' | 'createdAt' | 'tenantId'>): Promise<string> => {
  const docRef = await addDoc(getCollection(tenantId), {
    ...period,
    tenantId,
    createdAt: serverTimestamp()
  });
  return docRef.id;
};

export const updatePayrollPeriodStatus = async (tenantId: string, periodId: string, status: PayrollPeriodStatus, updatedBy: string): Promise<void> => {
  const docRef = doc(getCollection(tenantId), periodId);
  await updateDoc(docRef, { status, updatedBy });
};

export const isPayrollPeriodLocked = async (tenantId: string, tipDate: string): Promise<boolean> => {
  const q = query(getCollection(tenantId), where('status', 'in', ['Locked', 'Processed']));
  const snapshot = await getDocs(q);
  for (const doc of snapshot.docs) {
    const period = doc.data() as PayrollPeriod;
    if (tipDate >= period.startDate && tipDate <= period.endDate) {
      return true;
    }
  }
  return false;
};
